export default {"src":"/_next/static/media/digestion.3624f926.svg","height":34,"width":30};